// extracted by mini-css-extract-plugin
export default {"container":"TeamLayout--container--b83c30","contentWrapper":"TeamLayout--contentWrapper--8d1695","content":"TeamLayout--content--3aa3b2"};